import { createSlice } from "@reduxjs/toolkit";
import { getRRAxios, postRRAxios } from "./axiosActions";
import _ from 'lodash';

export const initialReviewFilter = {
    hideResponse: false, hideNoText: false, hideDoNotRespond: false, responseType: 1,
    sentiment: [], starRating: [], sortOrder: 'By Review Date', sortOrdertype: 'desc',
    isChangeDefault: false,
    withText: false, noText: false,
    noResponse: false, hasResponse: false,
    hasResponse: false, hasIssues: false,
    awaitingResponse: false, noResponseNecessary: false,
    selectedReviewId: null, dateSort: true,
    positive: false, negative: false, topicFilter: [],
    topicFilterType: 0,
    ratingSort: false, sortDir: 'desc',withoutTopics:false,
}

export const initialState = {
    loadingSetFilter: false,
    loadingGetFilter: false,
    hasErrors: false,
    filters: [],
    locationGroupBy: localStorage.getItem('locationSortBy') ?? 'state',
    reviewFilter: initialReviewFilter,
    dashboadViewType: 0,
};

const filtersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setFilters: (state, data) => {
            state.loadingSetFilter = true;
        },
        setFiltersSuccess: (state, { payload }) => {
            state.filters = payload;
            state.loadingSetFilter = false;
            state.hasErrors = false;
        },
        setFiltersFailure: state => {
            state.loadingSetFilter = false;
            state.hasErrors = true;
        },
        getFilters: state => {
            state.loadingGetFilter = true;
        },
        getFiltersSuccess: (state, { payload }) => {
            state.filters = payload;
            state.loadingGetFilter = false;
            state.hasErrors = false;
        },
        getFiltersFailure: state => {
            state.loadingGetFilter = false;
            state.hasErrors = true;
        },
        setLocationGroupBy: (state, { payload }) => {
            state.locationGroupBy = payload ?? 'state';
        },
        setDashboadViewType: (state, { payload }) => {
            state.dashboadViewType = payload ?? 0;
        },
        setReviewFilter: (state, { payload }) => {
            if (payload?.isSingle && payload?.key) {
                state.reviewFilter[payload?.key] = payload?.value;
            }
            else {
                state.reviewFilter = payload.value
            }

        },
    },
});

export const { getFilters, getFiltersFailure, getFiltersSuccess,
    setFilters, setFiltersFailure, setFiltersSuccess, setLocationGroupBy, setDashboadViewType,
    setReviewFilter } = filtersSlice.actions;
export const filtersSelector = state => state.filters;
export default filtersSlice.reducer;

export function loadFilters(companyId) {
    return async dispatch => {
        dispatch(getFilters());
        try {
            const filter = localStorage.getItem('filter') && JSON.parse(localStorage.getItem('filter'))?.[companyId]
            if (filter) {
                dispatch(getFiltersSuccess(filter?.[companyId]));
            }
            else {
                const params = { callTime: new Date() };
                const response = await getRRAxios('api/Filters/GetFilters?companyId=' + companyId, { params: params });
                // sessionStorage.setItem('filter', JSON.stringify(response));
                let filter = { [companyId]: response, activeCompanyId: companyId }
                if (localStorage.getItem('filter')) {
                    filter = localStorage.getItem('filter') && JSON.parse(localStorage.getItem('filter'))
                    filter['activeCompanyId'] = companyId
                    filter[companyId] = response
                }
                localStorage.setItem('filter', JSON.stringify(filter));
                dispatch(getFiltersSuccess(response));
            }

        } catch (error) {
            dispatch(getFiltersFailure());
        }
    };
}
export function bindFilters(input) {

    return async dispatch => {
        dispatch(setFilters(input));
        try {
            
            const response = await postRRAxios('api/Filters/SetFilters', { params: input });
            if (response?.statusCode === 200) {
                let filter = localStorage.getItem('filter') && JSON.parse(localStorage.getItem('filter'))
                if (filter?.[input.companyId]) {

                    filter = _.omit(filter, [[input.companyId]]);
                    localStorage.setItem('filter', JSON.stringify(filter));
                }
                // localStorage.removeItem('filter');
                dispatch(loadFilters(input.companyId));
            }
            dispatch(setFiltersSuccess(response));

        } catch (error) {
            dispatch(setFiltersFailure());
        }
    };
}

